import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class ShiftSettingRegionEntity {
  region?: RegionMiniEntity | null
  generateJobPeriodInDays?: number | null
  numberOfGeneratedDays?: number | null
}
